(function () {
  document.addEventListener(
    'play',
    function (e) {
      var target = e.target;
      if (target.tagName !== 'VIDEO') return;
      var root = target.closest('[data-product-ugc-reels]');
      if (!root) return;
      root.querySelectorAll('video').forEach(function (video) {
        if (video !== target && !video.classList.contains('product-ugc-modal__video')) {
          video.pause();
        }
      });
    },
    true
  );

  function getRoot(modalOrRoot) {
    if (modalOrRoot.matches && modalOrRoot.matches('[data-product-ugc-reels]')) {
      return modalOrRoot;
    }

    var sectionId = modalOrRoot.dataset.ugcSectionId;
    if (sectionId) {
      return document.querySelector(
        '[data-product-ugc-reels][data-ugc-section-id="' + sectionId + '"]'
      );
    }

    return modalOrRoot.closest('[data-product-ugc-reels]');
  }

  function getSlides(modal) {
    var root = getRoot(modal);
    if (!root) return [];
    return Array.from(root.querySelectorAll('.product-ugc-reels__slide'));
  }

  function getSlideMediaType(slide) {
    if (slide.dataset.ugcMediaType) {
      return slide.dataset.ugcMediaType;
    }
    return slide.querySelector('.product-ugc-reels__video') ? 'video' : 'image';
  }

  function copyVideoToModal(sourceVideo, modalVideo, shouldAutoplay) {
    modalVideo.innerHTML = '';
    sourceVideo.querySelectorAll('source').forEach(function (source) {
      modalVideo.appendChild(source.cloneNode(true));
    });

    if (sourceVideo.src) {
      modalVideo.src = sourceVideo.src;
    }

    var poster = sourceVideo.getAttribute('poster');
    if (poster) {
      modalVideo.setAttribute('poster', poster);
    } else {
      modalVideo.removeAttribute('poster');
    }

    modalVideo.muted = true;
    modalVideo.controls = true;
    modalVideo.load();

    var resumeAt = shouldAutoplay ? 0 : sourceVideo.currentTime || 0;

    function applyResumeTime() {
      modalVideo.currentTime = resumeAt;
      if (shouldAutoplay) {
        modalVideo.play().catch(function () {});
      }
    }

    if (modalVideo.readyState >= 1) {
      applyResumeTime();
    } else {
      modalVideo.addEventListener('loadedmetadata', applyResumeTime, { once: true });
    }
  }

  function copyImageToModal(sourceImage, modalImage) {
    var fullSrc = sourceImage.dataset.ugcFullSrc;
    modalImage.src = fullSrc || sourceImage.currentSrc || sourceImage.src;
    modalImage.srcset = fullSrc ? '' : sourceImage.srcset || '';
    modalImage.sizes = fullSrc ? '' : sourceImage.sizes || '';
    modalImage.alt = sourceImage.alt || '';
  }

  function updateNavButtons(modal, index, total) {
    var prevButton = modal.querySelector('[data-ugc-prev]');
    var nextButton = modal.querySelector('[data-ugc-next]');

    if (prevButton) {
      prevButton.disabled = index <= 0;
    }

    if (nextButton) {
      nextButton.disabled = index >= total - 1;
    }
  }

  function updateCounter(modal, index, total) {
    var counter = modal.querySelector('[data-ugc-counter]');
    if (!counter) return;
    counter.textContent = index + 1 + ' / ' + total;
  }

  function updatePostLink(modal, slide) {
    var link = modal.querySelector('[data-ugc-link]');
    if (!link) return;

    var postLink = slide.dataset.ugcPostLink;
    if (postLink) {
      link.href = postLink;
      link.hidden = false;
    } else {
      link.hidden = true;
      link.removeAttribute('href');
    }
  }

  function updateStage(modal, mediaType) {
    var stage = modal.querySelector('[data-ugc-stage]');
    if (!stage) return;

    stage.classList.remove('product-ugc-modal__stage--video', 'product-ugc-modal__stage--image');
    stage.classList.add(
      mediaType === 'video'
        ? 'product-ugc-modal__stage--video'
        : 'product-ugc-modal__stage--image'
    );
  }

  function pauseCarouselVideos(root) {
    if (!root) return;
    root.querySelectorAll('.product-ugc-reels__video').forEach(function (video) {
      video.pause();
    });
  }

  function showSlideInModal(modal, index, shouldAutoplay) {
    var slides = getSlides(modal);
    if (!slides.length) return;

    var nextIndex = Math.max(0, Math.min(index, slides.length - 1));
    var slide = slides[nextIndex];
    var mediaType = getSlideMediaType(slide);
    var modalVideo = modal.querySelector('.product-ugc-modal__video');
    var modalImage = modal.querySelector('.product-ugc-modal__image');
    var root = getRoot(modal);

    if (!modalVideo || !modalImage) return;

    pauseCarouselVideos(root);
    modalVideo.pause();
    modalVideo.hidden = true;
    modalImage.hidden = true;
    updateStage(modal, mediaType);

    if (mediaType === 'video') {
      var sourceVideo = slide.querySelector('.product-ugc-reels__video');
      if (!sourceVideo) return;

      modalVideo.hidden = false;
      copyVideoToModal(sourceVideo, modalVideo, shouldAutoplay === true);
    } else {
      var sourceImage = slide.querySelector('.product-ugc-reels__image');
      if (!sourceImage) return;

      modalImage.hidden = false;
      copyImageToModal(sourceImage, modalImage);
    }

    modal.dataset.activeIndex = String(nextIndex);
    updateNavButtons(modal, nextIndex, slides.length);
    updateCounter(modal, nextIndex, slides.length);
    updatePostLink(modal, slide);

    if (typeof slide.scrollIntoView === 'function') {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function openModal(modal, slide, opener) {
    var slides = getSlides(modal);
    var index = slides.indexOf(slide);
    if (index < 0) return;

    showSlideInModal(modal, index, false);
    modal.show(opener);

    var modalVideo = modal.querySelector('.product-ugc-modal__video');
    if (modalVideo && !modalVideo.hidden) {
      modalVideo.play().catch(function () {});
    }
  }

  document.addEventListener('click', function (e) {
    var expandButton = e.target.closest('[data-ugc-expand]');
    if (expandButton) {
      e.preventDefault();
      e.stopPropagation();

      var slide = expandButton.closest('.product-ugc-reels__slide');
      var modalId = expandButton.getAttribute('aria-controls');
      var modal = modalId ? document.getElementById(modalId) : null;

      if (!modal || !slide || typeof modal.show !== 'function') return;

      openModal(modal, slide, expandButton);
      return;
    }

    var prevButton = e.target.closest('[data-ugc-prev]');
    var nextButton = e.target.closest('[data-ugc-next]');
    var navButton = prevButton || nextButton;

    if (!navButton || navButton.disabled) return;

    var modal = navButton.closest('.product-ugc-modal');
    if (!modal || !modal.hasAttribute('open')) return;

    e.preventDefault();

    var currentIndex = parseInt(modal.dataset.activeIndex || '0', 10);
    showSlideInModal(modal, prevButton ? currentIndex - 1 : currentIndex + 1, true);
  });

  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('.product-ugc-modal[open]');
    if (!modal) return;

    if (e.key === 'ArrowLeft') {
      var prevButton = modal.querySelector('[data-ugc-prev]');
      if (prevButton && !prevButton.disabled) {
        e.preventDefault();
        prevButton.click();
      }
    }

    if (e.key === 'ArrowRight') {
      var nextButton = modal.querySelector('[data-ugc-next]');
      if (nextButton && !nextButton.disabled) {
        e.preventDefault();
        nextButton.click();
      }
    }
  });
})();
